import { Guid } from "guid-typescript";
import { IMessage } from "../../IMessage";

//Generated code, do not modify

export class GetActivityGroupQuery implements IMessage {
    id!: Guid;

    public constructor(init?: Partial<GetActivityGroupQuery>) {
        Object.assign(this, init);
    }

    getMethod = () => "GET";

    getUrl = () => `/admin/activity-groups/${this.id.toString()}`;

    getQueryString = () => undefined;

    getBody = () => undefined;
}